import ChargeDriverListView from '../../components/ChargeDriverListView';

ChargeDriverListScreen.propTypes = {};

function ChargeDriverListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargeDriverListView />
    </div>
  );
}

export default ChargeDriverListScreen;
